<template>
  <sc-image v-if="isEditMode" :media="media" :editable="editable"/>
  <!-- todo: need refactor -->
  <picture v-else>
    <source media="(max-width: 512px)" :srcset="imageSources.cloudinary_3x4_fill_crop">
    <source media="(max-width: 768px)" :srcset="imageSources.cloudinary_5x3_fill_crop">
    <img :src="imageSources.cloudinary_1x1_fill_crop" :alt="imageSources.alt"/>
  </picture>
</template>

<script>
import { Image } from '@sitecore-jss/sitecore-jss-vue'
import { createNamespacedHelpers } from 'vuex'
import get from '~/helpers/get'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'CustomPicture',

  components: {
    ScImage: Image
  },

  props: {
    media: {
      type: Object,
      default: () => ({})
    },
    editable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapJssGetters(['isEditMode']),

    imageSources () {
      return get(this.media, 'fields.mainImage.value')
    }
  }
}
</script>
